import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "app/services/user/auth.service";
import { LocalStorageService } from "angular-2-local-storage";

@Injectable()
export class SseService {

  private baseUrl = '/k7o/kss-airship';

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService
  ) {}

  private getToken(): string {
    let userData: any = null;

    if (this.localStorageService.get('userData') != null) {
      userData = this.localStorageService.get('userData');
    } else if (sessionStorage.getItem('userData') != null) {
      userData = JSON.parse(sessionStorage.getItem('userData'));
    }

    if (userData && userData.token) {
      return userData.token;
    }
    return null;
  }
startChallengeUpdates(challengeId: number): Observable<string> {
  var self = this;
  return new Observable(function(observer) {
    var abortController = new (window as any).AbortController();  // 👈 cast
    var token = self.getToken();
    var headers: any = {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream'
    };
    if (token) {
      headers['Authorization'] = 'Bearer ' + token;
    }

    fetch(`${self.baseUrl}/updates/sse`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ challengeId: challengeId }),
      signal: abortController.signal
    } as any)  // 👈 cast
      .then(function(response) {
        if (!response.ok) {
          observer.error('Risposta non ok: ' + response.status);
          return;
        }
        if (!response.body) {
          observer.error('Response body vuoto');
          return;
        }
        var reader = response.body.getReader();
        var decoder = new (window as any).TextDecoder();
        function read() {
          reader.read().then(function(result) {
            if (result.done) {
              observer.complete();
              return;
            }
            var chunk = decoder.decode(result.value, { stream: true });
            observer.next(chunk);
            read();
          }).catch(function(err) {
            if (err.name !== 'AbortError') {
              observer.error(err);
            }
          });
        }
        read();
      })
      .catch(function(err) {
        if (err.name !== 'AbortError') {
          observer.error(err);
        }
      });

    return function() {
      abortController.abort();
    };
  });
}
}


// WEBPACK FOOTER //
// ./src/app/views/notification/services/sse-service.service.ts